export default function Footer() {
  return (
    <footer className="relative pt-8 pb-14 text-center" data-testid="footer">
      <svg width="180" height="14" viewBox="0 0 180 14" className="mx-auto">
        <path d="M0 7 H74" stroke="#C29A3B" strokeWidth="1" />
        <path d="M106 7 H180" stroke="#C29A3B" strokeWidth="1" />
        <path d="M90 1 L96 7 L90 13 L84 7 Z" fill="#C29A3B" />
        <circle cx="80" cy="7" r="1.6" fill="#C29A3B" />
        <circle cx="100" cy="7" r="1.6" fill="#C29A3B" />
      </svg>
      <p className="mt-5 px-4 font-display text-2xl md:text-3xl text-kula-maroon leading-relaxed">
        এই শুভলগ্নে আপনাদের সাদর আমন্ত্রণ রইল
      </p>
    </footer>
  );
}
